import React from 'react';

import { Paper, Typography } from '@mui/material';

interface Props {
  title: string;
}

export default function TabPlaceholder({ title }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Typography variant="h6">{title}</Typography>
    </Paper>
  );
}
